/// <reference path="../../../app.definition.ts" />

import angular from 'angular';
export interface IcheckAccess {
    checkAccessForTarget(
        checkAccessFor?: {
            partyId: string | number,
            target: string
        }
    ): any;
    checkActionAllowed(
        action: string,
        checkAccessFor?: {
            partyId: string | number,
            target: string
        },
    ): any

}
class EcvCheckAccess implements IcheckAccess {
    urlRefreshed: boolean = false;
    static $inject = ['ApiAdapterService', '$q', "PermissionService"];
    constructor(
        private ApiAdapterService,
        private $q,
        private PermissionService,
    ) { }

    checkAccessForTarget = (checkAccessFor) => {
        const deferred = this.$q.defer();
        // console.log("type", typeof checkAccessFor.partyId, checkAccessFor)
        this.PermissionService.getPermissionsForTarget(checkAccessFor.target, [checkAccessFor.partyId]).then(data => {
            angular.equals(data[0], {}) ?
                deferred.resolve({ isPermCheckReq: false }) :
                deferred.resolve({ isPermCheckReq: data && true, [checkAccessFor.target]: data[0][checkAccessFor.target] })
        })

        return deferred.promise
    }
    checkActionAllowed = (action, checkAccessFor) => {
        const deferred = this.$q.defer();
        this.PermissionService.isActionAllowed(checkAccessFor.partyId, checkAccessFor.target, action).then(data => {
            deferred.resolve(data);
        })

        return deferred.promise
    }

}

angular.module('eCareVault.common.directives').directive('checkAccessFor', [function () {


    function link(scope, element, attrs, controller: IcheckAccess) {
        element.hide()
        if (!scope.checkOldAccess) {
            controller.checkActionAllowed(attrs.action, scope.checkAccessFor)
                .then((data) => {
                    if (scope.byPassPermission) {
                        element.remove()
                    }
                    else if (!data) {
                        element.remove()
                    } else {
                        element.show()
                    }
                });
        } else {
            element.show()
        }

        // if (scope.checkAccessFor) {
        //     controller.checkActionAllowed(attrs.action, scope.checkAccessFor).then(data => {
        //         console.log(`${scope.checkAccessFor.partyId}-${attrs.action}-data`, data, scope)
        //         let permissionCheck = scope.extraCondition ? (scope.extraCondition && data) : data;
        //         // hiding based on Permissions
        //         if (scope.checkOldAccess || permissionCheck ) {
        //             element.show()
        //         }
        //         else {
        //             element.remove()
        //         }
        //     }
        //     )
        // } else {
        //     !scope.checkOldAccess && element.remove()
        // }

    }

    return {
        scope: {
            action: "=",
            checkOldAccess: '=oldAccess',
            checkAccessFor: "=",
            byPassPermission: '=?'
        },
        controller: EcvCheckAccess,
        replace: true,
        link: link

    }
}]);


